module.exports = __webpack_public_path__ + "static/media/angle-double-up.17dbe9af.svg";